import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
export const RadioButton = forwardRef(({ children, id, value, onChange, name, color = 'secondary', size, checked, disabled, dataTestId, className }, ref) => {
    const labelClassName = classNames('flex items-center gap-2 group w-fit', checked ? 'font-bold' : 'font-medium', disabled ? 'text-gray' : 'text-gray-700 cursor-pointer', {
        'text-mBase md:text-base': !size,
        'text-sm': size === 'sm',
        'text-base': size === 'md',
        'text-mBase': size === 'lg'
    }, className);
    const roundedBorderClassName = classNames(`rounded-full`, {
        'border border-gray-400': !checked,
        'group-hover:border-gray': !checked && !disabled,
        'w-5 h-5 min-w-[1.25rem] md:w-4 md:h-4 md:min-w-[1rem]': !size,
        'border-[6px] md:border-[5px]': !size && checked,
        'w-4 h-4 min-w-[1rem]': size === 'sm' || size === 'md',
        'border-[5px]': (size === 'sm' || size === 'md') && checked,
        'w-5 h-5 min-w-[1.25rem]': size === 'lg',
        'border-[6px]': size === 'lg' && checked,
        'border-secondary': !disabled && checked && color === 'secondary',
        'border-blue': !disabled && checked && color === 'blue',
        'bg-gray-200 text-gray': disabled,
        'border-gray': disabled && checked
    });
    return (_jsxs("label", { className: labelClassName, htmlFor: id, children: [_jsx("input", { checked: checked, className: "absolute opacity-0 peer", "data-testid": `${dataTestId}_${checked}`, disabled: disabled, id: id, name: name, ref: ref, type: "radio", value: value, onChange: onChange }), _jsx("div", { className: roundedBorderClassName }), children] }));
});
